/**
 * missing-fsm-coverage lint rule — state machines whose `domain` field
 * references a domain id that does not exist in manifest.domains[].
 * Indicates a stale FSM entry or a parser configuration error.
 */
import type { AtlasManifest } from '../types.js';

export interface MissingFsmCoverageFinding {
  ref: string;
  message: string;
}

export function missingFsmCoverage(manifest: AtlasManifest): MissingFsmCoverageFinding[] {
  const domainIds = new Set(manifest.domains.map((d) => d.id));
  const findings: MissingFsmCoverageFinding[] = [];

  for (const fsm of manifest.stateMachines) {
    if (!domainIds.has(fsm.domain)) {
      findings.push({
        ref: fsm.id,
        message: `State machine ${fsm.id} references unknown domain "${fsm.domain}"`,
      });
    }
  }

  return findings;
}
